export default __webpack_public_path__ + "static/media/3.5e6950c7.jpg";